import React from "react";
import SidebarContent from "../SidebarContentContainer/SidebarContentContainer";
import SidebarClose from "../SidebarClose/SidebarClose";
import styles from "./Sidebar.module.css";
import { useSidebarContext } from "../../contexts/SidebarContext";
const Sidebar: React.FC = () => {
    const { isOpen } = useSidebarContext();
    return (
        <div
            className={styles["side-bar"] + (isOpen ? " " + styles["side-bar-active"] : "")}
        >
            <SidebarContent />
            <SidebarClose />
        </div>
    );
};

export default Sidebar;